import { get } from 'lodash';
import React from 'react';
import { LEARNING_ASSET_DURATIONS, LEARNING_ASSET_TYPES } from '../../../../shared/Constants';
import VerbText from '../../../../shared/components/VerbText';

export const getCardColor = (type) => {
    if (type === LEARNING_ASSET_TYPES.IMPACT_PROJECT || type === LEARNING_ASSET_TYPES.TRACK) {
        return 'Primary1';
    }
    if (
        type === LEARNING_ASSET_TYPES.ARTICLE ||
        type === LEARNING_ASSET_TYPES.SINGLE_PAGE_ACTIVITY ||
        type === LEARNING_ASSET_TYPES.ACTIVITY ||
        type === LEARNING_ASSET_TYPES.VIDEO
    ) {
        return 'Primary2';
    }
    if (
        type === LEARNING_ASSET_TYPES.ASSESSMENT ||
        type === LEARNING_ASSET_TYPES.PRE_ASSESSMENT ||
        type === LEARNING_ASSET_TYPES.POST_ASSESSMENT
    ) {
        return 'Primary4';
    }
    return null;
};

export const getDurationDisplay = (learningAsset) => {
    const duration = get(learningAsset, 'track.duration', '');
    const durationId = get(learningAsset, 'track.durationId', '');
    const durationDisplay = durationId ? LEARNING_ASSET_DURATIONS()[durationId].label : duration;

    return durationDisplay;
};

export const renderCompletenessStatus = (learningAsset) => {
    if (learningAsset.status === 'COMPLETED') {
        return <VerbText messageId={'HEADING_DONE'} defaultMessage={'DONE'} />;
    }
    if (learningAsset.status === 'IN_PROGRESS') {
        return <VerbText messageId={'HEADING_IN_PROGRESS'} defaultMessage={'IN PROGRESS'} />;
    }
    return null;
};
